import React from 'react';
import YouTubeIcon from 'assets/img/Youtube_play_icon.svg';
import './YoutubeChannel.css';

const youtubeChannel = () => {
  return (
    <div className="video-card channel-card">
      <a href="https://www.youtube.com/user/DTRandy/videos" target="_blank" rel="noopener noreferrer">
        <img className='video-image channel-image' src={YouTubeIcon} alt="YouTube link" />
      </a>
      <div className="video-details">
        <p className="video-name">
          <a href="https://www.youtube.com/user/DTRandy/videos" target="_blank" rel="noopener noreferrer">
            Navštivte náš kanál na YouTube
          </a>
        </p>
        <p className="description">naleznete na něm videoklipy našich skladeb a záznamy koncertů a festivalů.</p>
        <p className="video-play video-youtube">
          <a href="https://www.youtube.com/user/DTRandy/videos" target="_blank" rel="noopener noreferrer">&rarr; Přejít na YouTube</a>
        </p>
      </div>
    </div>
  );
}

export default youtubeChannel;